import { render, staticRenderFns } from "./category-sort-modal.vue?vue&type=template&id=18695cc6&scoped=true&"
import script from "./category-sort-modal.vue?vue&type=script&lang=js&"
export * from "./category-sort-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18695cc6",
  null
  
)

export default component.exports